/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, Typography } from "@mui/material";
import DialogBase from "../DialogBase";
import ImageModel from "./ImageModel";
import ImageProps from "./ImageProps";

type StyledImageProps = Pick<ImageProps, "source" | "alternativ" | "quelle" | "background"> & { onClick?: () => void };

function StyledImage(props: StyledImageProps) {
    return (
        <Box sx={{ position: "relative", lineHeight: 0, cursor: props.onClick ? "pointer" : undefined }}>
            <Box
                className="lan-image-clarity"
                component="img"
                loading="lazy"
                bgcolor={props.background}
                sx={{ width: "100%", display: "block" }}
                src={props.source}
                alt={props.alternativ}
                onClick={props.onClick}
            >
            </Box>
            {!!props.quelle && (
                <Typography
                    component="span"
                    variant="caption"
                    title={props.quelle}
                    sx={{
                        bgcolor: "rgba(0, 0, 0, 0.75)",
                        position: "absolute",
                        maxWidth: "100%",
                        p: 0.25,
                        lineHeight: 1,
                        bottom: 0,
                        right: 0,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: theme => theme.palette.grey[400],
                    }}
                >
                    {props.quelle}
                </Typography>
            )}
        </Box>
    )
}

export default function Image(props: ImageProps) {
    const vm = new ImageModel(props);
    return (
        <Box sx={props.sx}>
            <StyledImage {...props} onClick={props.deaktiviereVorschaugrafik ? undefined : vm.blendeBildEin} />
            {!props.deaktiviereVorschaugrafik && (
                <DialogBase open={vm.state.isOpen} sx={{ lineHeight: 0 }} onClick={vm.blendeBildAus}>
                    <StyledImage {...props} onClick={vm.blendeBildAus} />
                </DialogBase>
            )}
        </Box>
    );
}
